import { Link } from "react-router-dom";
import { useReveal } from "../../../../hooks/useReveal";
import styles from "./Audience.module.css";

export default function Audience() {
  const { ref: ref1, isVisible: vis1 } = useReveal();
  const { ref: ref2, isVisible: vis2 } = useReveal();

  return (
    <section className={styles.section} id="audience">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Built for both sides</span>
          <h2 className={styles.h2}>
            Whether you're hiring or job hunting — start here.
          </h2>
        </div>

        <div className={styles.grid}>
          <div
            ref={ref1}
            className={`${styles.card} ${styles.employers} ${vis1 ? styles.visible : styles.hidden}`}
          >
            <div className={styles.audIcon}>🏢</div>
            <h3>For Employers</h3>
            <p>
              SMEs and startups: stop sifting through resumes. Get a curated,
              ranked shortlist of pre-vetted candidates within 48 hours of
              posting.
            </p>
            <Link
              to="/register?tab=client"
              className={`${styles.btn} ${styles.btnPrimary}`}
            >
              Find Talent →
            </Link>
          </div>

          <div
            ref={ref2}
            className={`${styles.card} ${styles.talent} ${vis2 ? styles.visible : styles.hidden}`}
          >
            <div className={styles.audIcon}>👤</div>
            <h3>For Job Seekers</h3>
            <p>
              Get verified once, then matched to roles that fit. No more cold
              applications — companies come to you with opportunities aligned to
              your skills.
            </p>
            <Link
              to="/register?tab=talent"
              className={`${styles.btn} ${styles.btnSecondary}`}
            >
              Sign Up Free →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
